import u, { isValidElement as g, cloneElement as w } from "react";
import E from "../../../../_virtual/isFunction.js";
import M from "../../../../_virtual/isPlainObject.js";
import A from "../../../../_virtual/isBoolean.js";
import T from "../../../../_virtual/isEqual.js";
import { Rectangle as z } from "../shape/Rectangle.js";
import { Trapezoid as C } from "../shape/Trapezoid.js";
import { Sector as F } from "../shape/Sector.js";
import { Layer as N } from "../container/Layer.js";
import { Symbols as K } from "../shape/Symbols.js";
var B = ["option", "shapeType", "propTransformer", "activeClassName", "isActive"];
function a(e) {
  "@babel/helpers - typeof";
  return a = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
    return typeof r;
  } : function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, a(e);
}
function V(e, r) {
  if (e == null) return {};
  var n = L(e, r), t, o;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (o = 0; o < i.length; o++)
      t = i[o], !(r.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (n[t] = e[t]);
  }
  return n;
}
function L(e, r) {
  if (e == null) return {};
  var n = {};
  for (var t in e)
    if (Object.prototype.hasOwnProperty.call(e, t)) {
      if (r.indexOf(t) >= 0) continue;
      n[t] = e[t];
    }
  return n;
}
function h(e, r) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(e);
    r && (t = t.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, t);
  }
  return n;
}
function c(e) {
  for (var r = 1; r < arguments.length; r++) {
    var n = arguments[r] != null ? arguments[r] : {};
    r % 2 ? h(Object(n), !0).forEach(function(t) {
      R(e, t, n[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : h(Object(n)).forEach(function(t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
    });
  }
  return e;
}
function R(e, r, n) {
  return r = W(r), r in e ? Object.defineProperty(e, r, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = n, e;
}
function W(e) {
  var r = q(e, "string");
  return a(r) == "symbol" ? r : r + "";
}
function q(e, r) {
  if (a(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var t = n.call(e, r);
    if (a(t) != "object") return t;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r === "string" ? String : Number)(e);
}
function D(e, r) {
  return c(c({}, r), e);
}
function G(e, r) {
  return e === "symbols";
}
function O(e) {
  var r = e.shapeType, n = e.elementProps;
  switch (r) {
    case "rectangle":
      return /* @__PURE__ */ u.createElement(z, n);
    case "trapezoid":
      return /* @__PURE__ */ u.createElement(C, n);
    case "sector":
      return /* @__PURE__ */ u.createElement(F, n);
    case "symbols":
      if (G(r))
        return /* @__PURE__ */ u.createElement(K, n);
      break;
    default:
      return null;
  }
}
function H(e) {
  return /* @__PURE__ */ g(e) ? e.props : e;
}
function sr(e) {
  var r = e.option, n = e.shapeType, t = e.propTransformer, o = t === void 0 ? D : t, i = e.activeClassName, p = i === void 0 ? "recharts-active-shape" : i, y = e.isActive, l = V(e, B), s;
  if (/* @__PURE__ */ g(r))
    s = /* @__PURE__ */ w(r, c(c({}, l), H(r)));
  else if (E(r))
    s = r(l);
  else if (M(r) && !A(r)) {
    var d = o(r, l);
    s = /* @__PURE__ */ u.createElement(O, {
      shapeType: n,
      elementProps: d
    });
  } else {
    var f = l;
    s = /* @__PURE__ */ u.createElement(O, {
      shapeType: n,
      elementProps: f
    });
  }
  return y ? /* @__PURE__ */ u.createElement(N, {
    className: p
  }, s) : s;
}
function m(e, r) {
  return r != null && "trapezoids" in e.props;
}
function b(e, r) {
  return r != null && "sectors" in e.props;
}
function v(e, r) {
  return r != null && "points" in e.props;
}
function J(e, r) {
  var n, t, o = e.x === (r == null || (n = r.labelViewBox) === null || n === void 0 ? void 0 : n.x) || e.x === r.x, i = e.y === (r == null || (t = r.labelViewBox) === null || t === void 0 ? void 0 : t.y) || e.y === r.y;
  return o && i;
}
function Q(e, r) {
  var n = e.endAngle === r.endAngle, t = e.startAngle === r.startAngle;
  return n && t;
}
function U(e, r) {
  var n = e.x === r.x, t = e.y === r.y, o = e.z === r.z;
  return n && t && o;
}
function X(e, r) {
  var n;
  return m(e, r) ? n = J : b(e, r) ? n = Q : v(e, r) && (n = U), n;
}
function Y(e, r) {
  var n;
  return m(e, r) ? n = "trapezoids" : b(e, r) ? n = "sectors" : v(e, r) && (n = "points"), n;
}
function Z(e, r) {
  if (m(e, r)) {
    var n;
    return (n = r.tooltipPayload) === null || n === void 0 || (n = n[0]) === null || n === void 0 || (n = n.payload) === null || n === void 0 ? void 0 : n.payload;
  }
  if (b(e, r)) {
    var t;
    return (t = r.tooltipPayload) === null || t === void 0 || (t = t[0]) === null || t === void 0 || (t = t.payload) === null || t === void 0 ? void 0 : t.payload;
  }
  return v(e, r) ? r.payload : {};
}
function ur(e) {
  var r = e.activeTooltipItem, n = e.graphicalItem, t = e.itemData, o = Y(n, r), i = Z(n, r), p = t.filter(function(l, s) {
    var d = T(i, l), f = n.props[o].filter(function(x) {
      var P = X(n, r);
      return P(x, r);
    }), S = n.props[o].indexOf(f[f.length - 1]), j = s === S;
    return d && j;
  }), y = t.indexOf(p[p.length - 1]);
  return y;
}
export {
  sr as Shape,
  J as compareFunnel,
  Q as comparePie,
  U as compareScatter,
  ur as getActiveShapeIndexForTooltip,
  H as getPropsFromShapeOption,
  m as isFunnel,
  b as isPie,
  v as isScatter
};
